<div *ngIf="isLoading$ | async; else outlet" class="auth0-loader">
    <syn-fullpage-loader></syn-fullpage-loader>
</div>

<ng-template #outlet>
    <router-outlet></router-outlet>
</ng-template>
